import { useEffect, useState, useRef } from "react";
import withRouterPageLayout from "@components/withRouterPageLayout";
import getConfig from "next/config";
import Head from "next/head";
import ErrorPage from "@containers/ErrorPage";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const PlaystationPage = () => {
  const [height, setHeight] = useState("100vh");
  const iframeRef = useRef();

  const iframeSrc =
    websiteName === "altex"
      ? "https://lcdn.altex.ro/media/ps5/"
      : "https://lcdn.mediagalaxy.ro/media/ps5-mg/";

  const handleIframeMessage = (event) => {
    const eventOrigin =
      websiteName === "altex"
        ? "https://lcdn.altex.ro"
        : "https://lcdn.mediagalaxy.ro";

    if (event.origin === eventOrigin) {
      if (event.data?.height) {
        setHeight(`${Number(event.data.height) + 60}px`);
      }

      if (event.data?.scrollTo) {
        const scrollPosition =
          iframeRef.current.offsetTop + event.data.scrollTo;

        scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        });
      }
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleIframeMessage);

    return () => {
      window.removeEventListener("message", handleIframeMessage);
    };
  }, []);

  if (websiteName === "bricostore") {
    return <ErrorPage layout="404" />;
  }

  return (
    <>
      <Head>
        <title>Playstation</title>
      </Head>

      <iframe
        className="border-0 w-full"
        src={iframeSrc}
        ref={iframeRef}
        title=""
        style={{ height }}
      />
    </>
  );
};

PlaystationPage.pageLayout = "default";

export default withRouterPageLayout(PlaystationPage);
